module.exports = __webpack_public_path__ + "img/stationLine.efc1783b.png";